var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-errors": _vm.validationErrors,
                    "validation-id": "MPZip"
                  }
                },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0", attrs: { "label-cols-sm": "12" } },
                    [
                      _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Postinumero")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("postal-autocomplete", {
                            attrs: {
                              id: "mpinformation_postalcode_field",
                              "street-locale": _vm.mpStreetLocale
                            },
                            on: {
                              "postal-code-selected":
                                _vm.meteringPointPostalSelected
                            },
                            model: {
                              value: _vm.postalStr,
                              callback: function($$v) {
                                _vm.postalStr = $$v
                              },
                              expression: "postalStr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "6", lg: "4" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-errors": _vm.validationErrors,
                    "validation-id": "MPStreet"
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: { "label-cols-sm": "12", "label-cols-md": "12" }
                    },
                    [
                      _vm.isMoveOut
                        ? _c(
                            "label",
                            { staticClass: "font-weight-bold pt-0" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("Loppulaskun osoite")) +
                                  "\n                            "
                              ),
                              _vm.additionalAddressToMeteringPointAddress
                                ? _c("font-awesome-icon", {
                                    style: _vm.tooltipStyle,
                                    attrs: {
                                      icon: "exclamation-circle",
                                      id: "tooltip-mp-street-invoicing",
                                      size: "lg"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.additionalAddressToMeteringPointAddress
                                ? _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "tooltip-mp-street-invoicing",
                                        variant: "primary",
                                        placement: "right",
                                        triggers: "hover"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              "Vaihdettu automaattisesti lisäosoitteen tilalle käyttöpaikan osoite."
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _c(
                            "label",
                            { staticClass: "font-weight-bold pt-0" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("Käyttöpaikan osoite")) +
                                  "\n                            "
                              ),
                              _vm.additionalAddressToMeteringPointAddress
                                ? _c("font-awesome-icon", {
                                    style: _vm.tooltipStyle,
                                    attrs: {
                                      icon: "exclamation-circle",
                                      id: "tooltip-mp-street",
                                      size: "lg"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.additionalAddressToMeteringPointAddress
                                ? _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "tooltip-mp-street",
                                        variant: "primary",
                                        placement: "right",
                                        triggers: "hover"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              "Vaihdettu automaattisesti lisäosoitteen tilalle käyttöpaikan osoite."
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                    ]
                  ),
                  _vm._v(" "),
                  _c("street-autocomplete", {
                    attrs: {
                      id: "mpinformation_mpstreet_field",
                      "postal-filter": _vm.contract.MeteringPoint.Address.Zip,
                      "zip-locale": _vm.mpZipLocale
                    },
                    on: { "street-selected": _vm.meteringPointStreetSelected },
                    model: {
                      value: _vm.mpStreetStr,
                      callback: function($$v) {
                        _vm.mpStreetStr = $$v
                      },
                      expression: "mpStreetStr"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "4", md: "3", lg: "2" } }, [
            _c(
              "div",
              {
                staticClass: "form-group metering-point-info",
                attrs: { "data-validation-id": "MPZip" }
              },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "12",
                      "label-cols-lg": "12"
                    }
                  },
                  [
                    _vm.contract.MeteringPoint.Address.Zip
                      ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                          _vm._v(_vm._s(_vm.$t("Postinumero")))
                        ])
                      : _c("label", { staticClass: "font-weight-bold pt-0" }, [
                          _vm._v(_vm._s(_vm.$t("")))
                        ])
                  ]
                ),
                _vm._v(" "),
                _c("p", {
                  staticClass: "form-control-static vertical",
                  attrs: { name: "MPZip" },
                  domProps: {
                    textContent: _vm._s(_vm.contract.MeteringPoint.Address.Zip)
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4", md: "3" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "12",
                    "label-cols-lg": "12"
                  }
                },
                [
                  _vm.contract.MeteringPoint.Address.Place
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Postitoimipaikka")))
                      ])
                    : _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("")))
                      ])
                ]
              ),
              _vm._v(" "),
              _c("p", {
                staticClass: "form-control-static vertical",
                domProps: {
                  textContent: _vm._s(_vm.contract.MeteringPoint.Address.Place)
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.offerRequest
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "6", sm: "6", md: "4", lg: "3" } }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          "label-cols-sm": "12",
                          "label-cols-md": "12",
                          "label-cols-lg": "12"
                        }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "font-weight-bold pt-0",
                            attrs: { for: "mp-code" }
                          },
                          [_vm._v(_vm._s(_vm.$t("Käyttöpaikkatunnus")))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "new-contract-value",
                          rawName: "v-new-contract-value"
                        }
                      ],
                      attrs: {
                        id: "mp-code",
                        type: "text",
                        name: "GsrnCode",
                        maxlength: "18",
                        disabled: _vm.disableMeteringPointcodeField
                      },
                      model: {
                        value: _vm.gsrnCode,
                        callback: function($$v) {
                          _vm.gsrnCode = $$v
                        },
                        expression: "gsrnCode"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "6", sm: "6", md: "4", lg: "3" } }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          "label-cols-sm": "12",
                          "label-cols-md": "12",
                          "label-cols-lg": "12"
                        }
                      },
                      [
                        _c("label", { staticClass: "font-weight-bold pt-0" }, [
                          _vm._v(_vm._s(_vm.$t("")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          "label-cols-sm": "12",
                          "label-cols-md": "12",
                          "label-cols-lg": "12",
                          "label-align-md": "right"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.contract.MeteringPoint.NetworkCompanyName)
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contract.MeteringPoint.SearchedNotFound && !_vm.offerRequest
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          "label-cols-sm": "24",
                          "label-cols-md": "24",
                          "label-cols-lg": "24"
                        }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "font-weight-bold pt-0",
                            staticStyle: { color: "red" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Tarkistathan vielä antamasi käyttöpaikan osoitetiedot ja jatka sopimuksen tekoa painamalla jatka."
                                )
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.offerRequest
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "checkbox-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "new-contract-value",
                          rawName: "v-new-contract-value"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "IsCustomerAddressInUse",
                        "true-value": "1",
                        "false-value": "0"
                      },
                      domProps: { checked: _vm.contract.IsCustomerAddressInUse }
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t(
                            "Postiosoitteeni on eri kuin käyttöpaikan osoite."
                          )
                        ) +
                        "\n                    "
                    )
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      [
        _c("transition", { on: { "after-enter": _vm.afterEnter_mp } }, [
          _vm.contract.IsCustomerAddressInUse
            ? _c("div", { staticClass: "card panel-default" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("Asiakkaan postiosoite")) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Mikäli teet sopimusta eri osoitteeseen kuin missä asut (esimerkiksi kesämökille), syötä oma osoitteesi tässä."
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-5" },
                          [
                            _c(
                              "validated-form-group",
                              {
                                staticClass: "no-margin-bottom",
                                attrs: {
                                  "validation-id": "Street",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": "12",
                                      "label-cols-md": "12",
                                      "label-cols-lg": "12"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "font-weight-bold pt-0" },
                                      [_vm._v(_vm._s(_vm.$t("Katuosoite")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("street-autocomplete", {
                                  attrs: {
                                    id: "meteringpointStreetStr_field",
                                    "postal-filter":
                                      _vm.contract.Customer.Address.Zip,
                                    "zip-locale": _vm.customerZipLocale
                                  },
                                  on: {
                                    "street-selected":
                                      _vm.customerStreetSelected
                                  },
                                  model: {
                                    value: _vm.customerStreetStr,
                                    callback: function($$v) {
                                      _vm.customerStreetStr = $$v
                                    },
                                    expression: "customerStreetStr"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-6 col-sm-6 col-md-3" },
                          [
                            _c(
                              "validated-form-group",
                              {
                                staticClass: "no-margin-bottom",
                                attrs: {
                                  "validation-id": "Zip",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": "12",
                                      "label-cols-md": "12",
                                      "label-cols-lg": "12"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "font-weight-bold pt-0" },
                                      [_vm._v(_vm._s(_vm.$t("Postinumero")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("postal-autocomplete", {
                                  attrs: {
                                    id: "meteringpointPostalCodeStr_field",
                                    "post-office-target":
                                      "#customer-post-office",
                                    "street-locale": _vm.customerStreetLocale
                                  },
                                  on: {
                                    "postal-code-selected":
                                      _vm.customerPostalSelected
                                  },
                                  model: {
                                    value: _vm.customerZipStr,
                                    callback: function($$v) {
                                      _vm.customerZipStr = $$v
                                    },
                                    expression: "customerZipStr"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 col-md-3" },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group no-margin-bottom" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": "12",
                                      "label-cols-md": "12",
                                      "label-cols-lg": "12"
                                    }
                                  },
                                  [
                                    _vm.customer.Address.Place
                                      ? _c(
                                          "label",
                                          {
                                            staticClass: "font-weight-bold pt-0"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Postitoimipaikka"))
                                            )
                                          ]
                                        )
                                      : _c(
                                          "label",
                                          {
                                            staticClass: "font-weight-bold pt-0"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("")))]
                                        )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", {
                                  staticClass: "form-control-static vertical",
                                  attrs: { id: "customer-post-office" },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.customer.Address.Place
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-5" },
                          [
                            _c(
                              "validated-form-group",
                              {
                                staticClass: "no-margin-bottom",
                                attrs: {
                                  "validation-id": "Street",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": "12",
                                      "label-cols-md": "12",
                                      "label-cols-lg": "12"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "font-weight-bold pt-0" },
                                      [_vm._v(_vm._s(_vm.$t("Katuosoite")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("street-autocomplete", {
                                  attrs: {
                                    id: "meteringpointStreetStr_field",
                                    "postal-filter":
                                      _vm.contract.MeteringPoint.Address.Zip,
                                    "zip-locale": _vm.companyZipLocale
                                  },
                                  on: {
                                    "street-selected": _vm.companyStreetSelected
                                  },
                                  model: {
                                    value: _vm.companyStreetStr,
                                    callback: function($$v) {
                                      _vm.companyStreetStr = $$v
                                    },
                                    expression: "companyStreetStr"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-6 col-sm-6 col-md-3" },
                          [
                            _c(
                              "validated-form-group",
                              {
                                staticClass: "no-margin-bottom",
                                attrs: {
                                  "validation-id": "Zip",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": "12",
                                      "label-cols-md": "12",
                                      "label-cols-lg": "12"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "font-weight-bold pt-0" },
                                      [_vm._v(_vm._s(_vm.$t("Postinumero")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("postal-autocomplete", {
                                  attrs: {
                                    id: "meteringpointPostalCodeStr_field",
                                    "post-office-target":
                                      "#company-post-office",
                                    "street-locale": _vm.companyStreetLocale
                                  },
                                  on: {
                                    "postal-code-selected":
                                      _vm.companyPostalSelected
                                  },
                                  model: {
                                    value: _vm.companyZipStr,
                                    callback: function($$v) {
                                      _vm.companyZipStr = $$v
                                    },
                                    expression: "companyZipStr"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 col-md-3" },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group no-margin-bottom" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": "12",
                                      "label-cols-md": "12",
                                      "label-cols-lg": "12"
                                    }
                                  },
                                  [
                                    _vm.company.Address.Place
                                      ? _c(
                                          "label",
                                          {
                                            staticClass: "font-weight-bold pt-0"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Postitoimipaikka"))
                                            )
                                          ]
                                        )
                                      : _c(
                                          "label",
                                          {
                                            staticClass: "font-weight-bold pt-0"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("")))]
                                        )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", {
                                  staticStyle: { "margin-top": "8px" },
                                  attrs: { id: "company-post-office" },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.company.Address.Place
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ])
      ],
      _vm._v(" "),
      !_vm.offerRequest
        ? [
            _c("div", { staticClass: "card panel-default" }, [
              _c("div", { staticClass: "card-header" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("Haluan sähkölaskuni")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: _vm.invoicingMethodELaskuStr,
                                expression: "invoicingMethodELaskuStr"
                              }
                            ],
                            staticClass: "form-group"
                          },
                          [
                            _c(
                              "validated-form-group",
                              {
                                staticClass: "no-margin-bottom",
                                attrs: {
                                  "validation-id": "InvoicingMethod",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "label-cols-sm": "12",
                                      "label-cols-md": "12",
                                      "label-cols-lg": "12"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "font-weight-bold pt-0" },
                                      [_vm._v(_vm._s(_vm.$t("Laskutustapa")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _vm.contract.CustomerType ==
                                    _vm.CustomerTypeEnum.CONSUMER
                                      ? _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip",
                                                value:
                                                  _vm.invoicingMethodELaskuStrDisabled,
                                                expression:
                                                  "invoicingMethodELaskuStrDisabled"
                                              }
                                            ],
                                            staticClass: "radio"
                                          },
                                          [
                                            _c("label", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "new-contract-value",
                                                    rawName:
                                                      "v-new-contract-value"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  name: "InvoicingMethod"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.InvoicingMethodEnum
                                                      .ConsumerEInvoice,
                                                  checked:
                                                    _vm.contract
                                                      .InvoicingMethod ==
                                                    _vm.InvoicingMethodEnum
                                                      .ConsumerEInvoice
                                                },
                                                on: {
                                                  "value-updated":
                                                    _vm.invoicingMethodChanged
                                                }
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "e-lasku (Kirjoita Lisätietoja-kenttään oman pankkisi nimi, esim. Osuuspankki)"
                                                    )
                                                  ) +
                                                  "\n                                            "
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.contract.CustomerType ==
                                    _vm.CustomerTypeEnum.COMPANY
                                      ? _c("div", { staticClass: "radio" }, [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "new-contract-value",
                                                  rawName:
                                                    "v-new-contract-value"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "InvoicingMethod"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.InvoicingMethodEnum
                                                    .CompanyEInvoice,
                                                checked:
                                                  _vm.contract
                                                    .InvoicingMethod ==
                                                  _vm.InvoicingMethodEnum
                                                    .CompanyEInvoice
                                              },
                                              on: {
                                                "value-updated":
                                                  _vm.invoicingMethodChanged
                                              }
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("verkkolasku")) +
                                                "\n                                            "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "label",
                                        { staticClass: "checkbox-inline" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.showInvoicingAddressSection,
                                                expression:
                                                  "showInvoicingAddressSection"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              name:
                                                "showInvoicingAddressSection",
                                              "true-value": "1",
                                              "false-value": "0",
                                              disabled:
                                                _vm.contract.InvoicingMethod !=
                                                  _vm.InvoicingMethodEnum
                                                    .ConsumerEInvoice &&
                                                _vm.contract.InvoicingMethod !=
                                                  _vm.InvoicingMethodEnum
                                                    .CompanyEInvoice
                                            },
                                            domProps: {
                                              checked:
                                                _vm.showInvoicingAddressSection ==
                                                1,
                                              checked: Array.isArray(
                                                _vm.showInvoicingAddressSection
                                              )
                                                ? _vm._i(
                                                    _vm.showInvoicingAddressSection,
                                                    null
                                                  ) > -1
                                                : _vm._q(
                                                    _vm.showInvoicingAddressSection,
                                                    "1"
                                                  )
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.showInvoicingAddressSection,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked ? "1" : "0"
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.showInvoicingAddressSection = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.showInvoicingAddressSection = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.showInvoicingAddressSection = $$c
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Haluan sähkölaskuni toiseen osoitteeseen"
                                                )
                                              ) +
                                              "\n                                            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        {
                                          staticStyle: { "margin-left": "20px" }
                                        },
                                        [
                                          _vm._v(
                                            "Voit lisätä erillisen laskutusosoitteen."
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "validated-form-group",
                                      {
                                        staticClass: "no-margin-bottom",
                                        attrs: {
                                          "validation-id": "DeliveryEmail",
                                          "validation-errors":
                                            _vm.validationErrors
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "radio" }, [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "new-contract-value",
                                                  rawName:
                                                    "v-new-contract-value"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "InvoicingMethod"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.InvoicingMethodEnum.Email,
                                                checked:
                                                  _vm.contract
                                                    .InvoicingMethod ==
                                                  _vm.InvoicingMethodEnum.Email
                                              },
                                              on: {
                                                "value-updated":
                                                  _vm.invoicingMethodChanged
                                              }
                                            }),
                                            _vm._v(
                                              " Sähköpostilaskuna\n                                                    "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.contract.DeliveryEmail,
                                                  expression:
                                                    "contract.DeliveryEmail"
                                                },
                                                {
                                                  name: "new-contract-value",
                                                  rawName:
                                                    "v-new-contract-value"
                                                }
                                              ],
                                              staticClass:
                                                "form-control contract-field",
                                              staticStyle: {
                                                width: "260px",
                                                display:
                                                  "inline-block !important"
                                              },
                                              attrs: {
                                                type: "email",
                                                name: "DeliveryEmail",
                                                maxlength: "100",
                                                disabled:
                                                  _vm.contract
                                                    .InvoicingMethod !=
                                                  _vm.InvoicingMethodEnum.Email
                                              },
                                              domProps: {
                                                value:
                                                  _vm.contract.DeliveryEmail
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.contract,
                                                    "DeliveryEmail",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showInvoicingAddressSection == 1
                    ? _c(
                        "b-row",
                        [
                          _vm.contract.CustomerType ==
                          _vm.CustomerTypeEnum.COMPANY
                            ? _c(
                                "b-col",
                                { attrs: { sm: "12", md: "4" } },
                                [
                                  _c(
                                    "validated-form-group",
                                    {
                                      staticClass: "no-margin-bottom",
                                      attrs: {
                                        "validation-id": "InvoicingContactName",
                                        "validation-errors":
                                          _vm.validationErrors
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            "label-cols-sm": "12",
                                            "label-cols-md": "12",
                                            "label-cols-lg": "12"
                                          }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-weight-bold pt-0",
                                              attrs: {
                                                for: "invoicing-contact"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Yhteyshenkilö"))
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.contract.InvoicingAddress
                                                .ContactPersonName,
                                            expression:
                                              "contract.InvoicingAddress.ContactPersonName"
                                          },
                                          {
                                            name: "new-contract-value",
                                            rawName: "v-new-contract-value"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "invoicing-contact",
                                          type: "text",
                                          name: "InvoicingContactPersonCompany",
                                          maxlength: "70"
                                        },
                                        domProps: {
                                          value:
                                            _vm.contract.InvoicingAddress
                                              .ContactPersonName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.contract.InvoicingAddress,
                                              "ContactPersonName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "12", md: "5" } },
                            [
                              _c(
                                "validated-form-group",
                                {
                                  staticClass: "no-margin-bottom",
                                  attrs: {
                                    "validation-id": "InvoicingStreet",
                                    "validation-errors": _vm.validationErrors
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": "12",
                                        "label-cols-md": "12",
                                        "label-cols-lg": "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "font-weight-bold pt-0",
                                          attrs: {
                                            for: "invoicingStreetStr_field"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Laskutusosoite"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("street-autocomplete", {
                                    attrs: {
                                      id: "invoicingStreetStr_field",
                                      "postal-filter":
                                        _vm.contract.InvoicingAddress.Address
                                          .Zip,
                                      "zip-locale": _vm.invoicingZipLocale
                                    },
                                    on: {
                                      "street-selected":
                                        _vm.invoicingStreetSelected
                                    },
                                    model: {
                                      value: _vm.invoicingStreetStr,
                                      callback: function($$v) {
                                        _vm.invoicingStreetStr = $$v
                                      },
                                      expression: "invoicingStreetStr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", sm: "12", md: "3" } },
                            [
                              _c(
                                "validated-form-group",
                                {
                                  staticClass: "no-margin-bottom",
                                  attrs: {
                                    "validation-id": "InvoicingZip",
                                    "validation-errors": _vm.validationErrors
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": "12",
                                        "label-cols-md": "12",
                                        "label-cols-lg": "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "font-weight-bold pt-0",
                                          attrs: {
                                            for: "invoicingPostalCodeStr_field"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Postinumero")))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("postal-autocomplete", {
                                    attrs: {
                                      id: "invoicingPostalCodeStr_field",
                                      "post-office-target":
                                        "#invoicing-post-office",
                                      "street-locale": _vm.invoicingStreetLocale
                                    },
                                    on: {
                                      "postal-code-selected":
                                        _vm.invoicingPostalSelected
                                    },
                                    model: {
                                      value: _vm.invoicingZipStr,
                                      callback: function($$v) {
                                        _vm.invoicingZipStr = $$v
                                      },
                                      expression: "invoicingZipStr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", sm: "12", md: "3" } },
                            [
                              _c(
                                "div",
                                { staticClass: "form-group no-margin-bottom" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": "12",
                                        "label-cols-md": "12",
                                        "label-cols-lg": "12"
                                      }
                                    },
                                    [
                                      _vm.contract.InvoicingAddress.Address
                                        .Place
                                        ? _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-weight-bold pt-0",
                                              attrs: {
                                                for: "invoicing-post-office"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("Postitoimipaikka")
                                                )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-weight-bold pt-0",
                                              attrs: {
                                                for: "invoicing-post-office"
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("")))]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass: "form-control-static vertical",
                                    attrs: { id: "invoicing-post-office" },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.contract.InvoicingAddress.Address
                                          .Place
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "12", md: "4" } },
                            [
                              _c(
                                "validated-form-group",
                                {
                                  staticClass: "no-margin-bottom",
                                  attrs: {
                                    "validation-id": "InvoicingCountry",
                                    "validation-errors": _vm.validationErrors
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": "12",
                                        "label-cols-md": "12",
                                        "label-cols-lg": "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "font-weight-bold pt-0",
                                          attrs: { for: "invoicing-country" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Maa")))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.contract.InvoicingAddress.Address
                                            .Country,
                                        expression:
                                          "contract.InvoicingAddress.Address.Country"
                                      },
                                      {
                                        name: "new-contract-value",
                                        rawName: "v-new-contract-value"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "invoicing-country",
                                      type: "text",
                                      name: "InvoicingCountry",
                                      maxlength: "100"
                                    },
                                    domProps: {
                                      value:
                                        _vm.contract.InvoicingAddress.Address
                                          .Country
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.contract.InvoicingAddress.Address,
                                          "Country",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.offerRequest
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          "label-cols-sm": "12",
                          "label-cols-md": "12",
                          "label-cols-lg": "12"
                        }
                      },
                      [
                        _c("label", { staticClass: "font-weight-bold pt-0" }, [
                          _vm._v(_vm._s(_vm.$t("Laskujen määrä vuodessa")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "InvoicingGroup",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c("label", { staticClass: "radio-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "InvoicingGroup"
                                },
                                domProps: {
                                  value: 4,
                                  checked: _vm.contract.InvoicingGroup == 4
                                }
                              }),
                              _vm._v(
                                " 4 " +
                                  _vm._s(_vm.$t("kpl")) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("label", { staticClass: "radio-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "InvoicingGroup"
                                },
                                domProps: {
                                  value: 6,
                                  checked: _vm.contract.InvoicingGroup == 6
                                }
                              }),
                              _vm._v(
                                " 6 " +
                                  _vm._s(_vm.$t("kpl")) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("label", { staticClass: "radio-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "InvoicingGroup"
                                },
                                domProps: {
                                  value: 12,
                                  checked: _vm.contract.InvoicingGroup == 12
                                }
                              }),
                              _vm._v(
                                " 12 " +
                                  _vm._s(_vm.$t("kpl")) +
                                  "\n                            "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.offerRequest
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12"
                      }
                    },
                    [
                      _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v("Sopimuksen teon syy")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "validated-form-group",
                    {
                      attrs: {
                        "validation-id": "ContractReason",
                        "validation-errors": _vm.validationErrors
                      }
                    },
                    [
                      _vm.customer.TrustedSource &&
                      (_vm.customerContracts == null ||
                        _vm.customerContracts.length != 0)
                        ? _c("div", { staticClass: "radio" }, [
                            _c(
                              "label",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.contract.ContractReason,
                                      expression: "contract.ContractReason"
                                    },
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "ContractReason"
                                  },
                                  domProps: {
                                    value: _vm.contractReasonContractChange,
                                    checked: _vm._q(
                                      _vm.contract.ContractReason,
                                      _vm.contractReasonContractChange
                                    )
                                  },
                                  on: {
                                    "value-updated": _vm.contractReasonChanged,
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.contract,
                                        "ContractReason",
                                        _vm.contractReasonContractChange
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" Tuotteen vaihto "),
                                _c("i", {
                                  staticClass: "fa fa-info-circle",
                                  attrs: {
                                    id:
                                      "contract-reason-contract-change-tooltip"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-tooltip", {
                                  attrs: {
                                    target:
                                      "contract-reason-contract-change-tooltip",
                                    title:
                                      "Minulla on jo sähkösopimus PKS:n kanssa, johon vaihdan nyt toisen tuotteen.",
                                    triggers: "hover"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "radio",
                          staticStyle: { "margin-top": "0" }
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.contract.ContractReason,
                                    expression: "contract.ContractReason"
                                  },
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "ContractReason"
                                },
                                domProps: {
                                  value: _vm.contractReasonMoveIn,
                                  checked: _vm._q(
                                    _vm.contract.ContractReason,
                                    _vm.contractReasonMoveIn
                                  )
                                },
                                on: {
                                  "value-updated": _vm.contractReasonChanged,
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.contract,
                                      "ContractReason",
                                      _vm.contractReasonMoveIn
                                    )
                                  }
                                }
                              }),
                              _vm._v(" Muutto "),
                              _c("i", {
                                staticClass: "fa fa-info-circle",
                                attrs: { id: "contract-reason-move-in-tooltip" }
                              }),
                              _vm._v(" "),
                              _c("b-tooltip", {
                                attrs: {
                                  target: "contract-reason-move-in-tooltip",
                                  title:
                                    "Minulla ei ole tällä käyttöpaikalla aiempaa sopimusta minkään myyjän kanssa.",
                                  triggers: "hover"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "radio" }, [
                        _c(
                          "label",
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contract.ContractReason,
                                  expression: "contract.ContractReason"
                                },
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              attrs: { type: "radio", name: "ContractReason" },
                              domProps: {
                                value: _vm.contractReasonSupplierChange,
                                checked: _vm._q(
                                  _vm.contract.ContractReason,
                                  _vm.contractReasonSupplierChange
                                )
                              },
                              on: {
                                "value-updated": _vm.contractReasonChanged,
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.contract,
                                    "ContractReason",
                                    _vm.contractReasonSupplierChange
                                  )
                                }
                              }
                            }),
                            _vm._v(" Myyjän vaihto "),
                            _c("i", {
                              staticClass: "fa fa-info-circle",
                              attrs: {
                                id: "contract-reason-supplier-change-tooltip"
                              }
                            }),
                            _vm._v(" "),
                            _c("b-tooltip", {
                              attrs: {
                                target:
                                  "contract-reason-supplier-change-tooltip",
                                title:
                                  "Minulla on käyttöpaikassa sopimus toisen myyjän kanssa ja haluan vaihtaa sähkönmyyjää. Hoidamme nykyisen sähkösopimuksen irtisanomisen puolestasi.",
                                triggers: "hover"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isPriimaPlus
        ? _c(
            "b-row",
            { staticClass: "priimaplus" },
            [
              _c("b-col", { attrs: { xs: "12" } }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "checkbox-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "new-contract-value",
                          rawName: "v-new-contract-value"
                        }
                      ],
                      staticClass: "contract-field",
                      attrs: {
                        type: "checkbox",
                        name: "ExtraServiceOrder",
                        "true-value": "1",
                        "false-value": "0"
                      },
                      domProps: { checked: _vm.contract.ExtraServiceOrder == 1 }
                    }),
                    _vm._v(
                      " Tilaan hinnankiinnityspalvelun (maksuton lisäpalvelu Priimaplus -asiakkaalle)\n                    "
                    )
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPreSelectedMembership()
        ? _c("div", [
            _vm.isPreSelectedMembership("omakotiliitto")
              ? _c("p", [
                  _vm._v(
                    "Omakotiliiton jäsenenä saat 50 %:n alennuksen kuukausimaksusta. Lisäksi Pohjois-Karjalan Sähkö Oy maksaa uusille jäsenille ensimmäisen vuoden jäsenmaksun."
                  )
                ])
              : _vm._e()
          ])
        : _vm.hasMembership
        ? _c("div", [_c("Membership")], 1)
        : _vm._e(),
      _vm._v(" "),
      !_vm.offerRequest
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "validated-form-group",
                    {
                      attrs: {
                        "validation-id": "StartDate",
                        "validation-errors": _vm.validationErrors
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-md": "12",
                            "label-cols-lg": "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold pt-0" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Sopimuksen toivottu alkamispäivämäärä"
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showOldContractStartMessage
                        ? [
                            _c(
                              "p",
                              [
                                _vm._v(
                                  "Sinun nykyinen " +
                                    _vm._s(_vm.getOldProductName()) +
                                    " sopimuksesi on määräaikainen " +
                                    _vm._s(
                                      _vm._f("date")(
                                        _vm.contract.OldContractEndDate
                                      )
                                    ) +
                                    " saakka. "
                                ),
                                _vm.showNewContractStartDateText(
                                  _vm.contract.OldContractEndDate
                                )
                                  ? [
                                      _vm._v(
                                        "\n    Uuden sopimuksen voimaantulopäivä on aikaisintaan " +
                                          _vm._s(
                                            _vm._f("date")(
                                              _vm.contract.OldContractEndDate
                                            )
                                          ) +
                                          ".\n"
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { xs: "12", sm: "12", md: "6", lg: "4" } },
                            [
                              _c("b-form-datepicker", {
                                directives: [
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                staticClass: "mb-2",
                                attrs: {
                                  id: "startdate-datepicker",
                                  placeholder: "pp.kk.vvvv",
                                  "start-weekday": "1",
                                  name: "StartDate",
                                  "date-format-options": {
                                    day: "numeric",
                                    month: "numeric",
                                    year: "numeric"
                                  },
                                  locale: _vm.datePickerlanguage,
                                  "hide-header": true,
                                  "label-help": "",
                                  "no-highlight-today": "",
                                  min: _vm.minDate,
                                  max: _vm.maxDate,
                                  "date-disabled-fn": _vm.disableDates
                                },
                                model: {
                                  value: _vm.startDate,
                                  callback: function($$v) {
                                    _vm.startDate = $$v
                                  },
                                  expression: "startDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-id": "ExtraInformation",
                    "validation-errors": _vm.validationErrors
                  }
                },
                [
                  _c(
                    "b-form-group",
                    [
                      _c(
                        "label",
                        {
                          staticClass: "font-weight-bold pt-0",
                          attrs: { for: "ExtraInformation" }
                        },
                        [_vm._v("Lisätietoja")]
                      ),
                      _vm._v(" "),
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "new-contract-value",
                            rawName: "v-new-contract-value"
                          }
                        ],
                        attrs: {
                          id: "ExtraInformation",
                          name: "ExtraInformation",
                          rows: "3",
                          maxlength: "1000",
                          placeholder: "Maksimipituus 1000 merkkiä"
                        },
                        model: {
                          value: _vm.contract.ExtraInformation,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "ExtraInformation", $$v)
                          },
                          expression: "contract.ExtraInformation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.offerRequest
        ? _c(
            "b-row",
            [
              _c("b-col", [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "Huomioithan, että verkkoyhtiö voi ottaa sinuun yhteyttä kytkennän turvallisuuden varmistamiseksi."
                      )
                    )
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }